export { default } from './productService';